import { nestApiClient } from './api-client';
import { AuthResponse } from '@wwe-portal/entities/auth.type';

export const loginWithScopely = async (data: {
  accessToken: string;
  deviceToken: string;
  id_token: string;
}) => {
  return nestApiClient.post<AuthResponse>('/auth/v2/scopely', data);
};

export const loginWithFacebook = async (data: {
  accessToken: string;
  deviceToken: string;
}) => {
  return nestApiClient.post<AuthResponse>('/auth/v2/fb', data);
};

export const logoutPortalV2 = async () => {
  return await nestApiClient.post('/auth/v2/logout');
};

export const cleanUpAccessToken = async () => {
  return await nestApiClient.post('/auth/v2/clean-up/cookie');
};

export const loginWithOneTimeToken = async (data: {
  token: string | null;
  deviceToken: string | undefined;
}) => {
  return await nestApiClient.post<AuthResponse>(
    `/auth/v2/onetime/validate`,
    data
  );
};
